"use client";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { Item, ItemContent, ItemTitle } from "@/components/ui/item";
import { UI } from "@/constants";
import { OrderDetailsType } from "@/types";
import { HTMLAttributes } from "react";
import { Pie, PieChart } from "recharts";

const chartConfig = {
  percentChangeAddedItems: {
    label: UI.labels.percentChangeAddedItems,
    color: "var(--chart-1)",
  },
  percentChangeDeliveredItems: {
    label: UI.labels.percentChangeDeliveredItems,
    color: "var(--chart-3)",
  },
  percentChangeRemovedItems: {
    label: UI.labels.percentChangeRemovedItems,
    color: "var(--chart-5)",
  },
} satisfies ChartConfig;

type OrderDetailsPieChartProps = HTMLAttributes<HTMLDivElement> & {
  orderDetails: OrderDetailsType;
};

export const OrderDetailsPieChart = ({ orderDetails, ...props }: OrderDetailsPieChartProps) => {
  if (!orderDetails) return;

  const chartData = [
    {
      label: UI.labels.percentChangeAddedItems,
      percent: orderDetails.percentChangeAddedItems,
      fill: "var(--color-percentChangeAddedItems)",
    },
    {
      label: UI.labels.percentChangeDeliveredItems,
      percent: orderDetails.percentChangeDeliveredItems,
      fill: "var(--color-percentChangeDeliveredItems)",
    },
    {
      label: UI.labels.percentChangeRemovedItems,
      percent: orderDetails.percentChangeRemovedItems,
      fill: "var(--color-percentChangeRemovedItems)",
    },
  ];

  return (
    <Item variant="outline" {...props} className="items-start">
      <ItemContent className="size-full justify-between">
        <ItemTitle>{UI.titles.deliveryRatio}</ItemTitle>
        <ChartContainer config={chartConfig}>
          <PieChart>
            <Pie data={chartData} dataKey="percent" nameKey="label" />
            <ChartTooltip
              content={<ChartTooltipContent formatter={(value, name) => [name, `: ${value}%`]} />}
            />
          </PieChart>
        </ChartContainer>
      </ItemContent>
    </Item>
  );
};
